// API configuration and base functions
const getApiBaseUrl = () => {
  // Em desenvolvimento, usa proxy configurado no craco.config.js
  if (process.env.NODE_ENV === "development") {
    return "/api";
  }

  // Em produção, usa window.REACT_APP_BACKEND_URL (injetado pelo entrypoint.sh)
  const envUrl = window.REACT_APP_BACKEND_URL;

  // Se envUrl está vazio ou é undefined, usa URL relativa para produção
  if (!envUrl || envUrl === "") {
    return "/api";
  }

  // Se a URL já termina com /api, usa como está
  if (envUrl.endsWith("/api")) {
    return envUrl;
  }

  // Se a URL não tem /api, adiciona
  return envUrl + "/api";
};

export const API_BASE_URL = getApiBaseUrl();

export { getApiBaseUrl };

// Generic API call function with JWT support
// O token JWT é adicionado automaticamente pelo fetchInterceptor
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };
  
  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    throw new Error(`API call failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

// API call with automatic token refresh
export const apiCallWithAuth = async (endpoint, options = {}, authContext = null) => {
  if (!authContext) {
    throw new Error('Auth context is required for authenticated API calls');
  }
  
  const { refreshAccessToken } = authContext;
  
  try {
    return await apiCall(endpoint, options);
  } catch (error) {
    // Se erro 401, tentar renovar token
    if (error.message.includes('401')) {
      const refreshed = await refreshAccessToken();
      if (refreshed) {
        // Tentar novamente com novo token
        return await apiCall(endpoint, options);
      }
    }
    throw error;
  }
};
